var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgClinic = function SvgClinic(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_2",
    className: "st0",
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 20,
    height: 20,
    display: "inline",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#139DA8",
    id: "svg_1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_00000036253214160751011830000015996527300281361809_",
    x: 5,
    y: 9.5,
    className: "st2",
    width: 1,
    height: 1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F0396D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 9,
    className: "st3",
    width: 2,
    height: 2,
    fill: "#F0396D",
    id: "svg_3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4_00000129198614163796229340000011156758546964017038_",
    x: 5,
    y: 12,
    className: "st2",
    width: 1,
    height: 1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F0396D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 11.5,
    className: "st3",
    width: 2,
    height: 2,
    fill: "#F0396D",
    id: "svg_5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy_00000163778884355225347490000016264170990841336977_",
    x: 8,
    y: 9.5,
    className: "st2",
    width: 1,
    height: 1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F0396D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 9,
    className: "st3",
    width: 2,
    height: 2,
    fill: "#F0396D",
    id: "svg_7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5_00000127008792049624172640000015806954846483935617_",
    x: 8,
    y: 12,
    className: "st2",
    width: 1,
    height: 1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F0396D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 11.5,
    className: "st3",
    width: 2,
    height: 2,
    fill: "#F0396D",
    id: "svg_9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2_00000172418627949959307720000003457557617570291089_",
    x: 11,
    y: 9.5,
    className: "st2",
    width: 1,
    height: 1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F0396D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 9,
    className: "st3",
    width: 2,
    height: 2,
    fill: "#F0396D",
    id: "svg_11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6_00000045580829320800026860000005311466462269065344_",
    x: 11,
    y: 12,
    className: "st2",
    width: 1,
    height: 1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F0396D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 11.5,
    className: "st3",
    width: 2,
    height: 2,
    fill: "#F0396D",
    id: "svg_13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3_00000017510077619950363500000004216274379981377467_",
    x: 14,
    y: 9.5,
    className: "st2",
    width: 1,
    height: 1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F0396D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 9,
    className: "st3",
    width: 2,
    height: 2,
    fill: "#F0396D",
    id: "svg_15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7_00000003810108047515986490000008193614852808561054_",
    x: 14,
    y: 12,
    className: "st2",
    width: 1,
    height: 1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F0396D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 11.5,
    className: "st3",
    width: 2,
    height: 2,
    fill: "#F0396D",
    id: "svg_17"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m10,8c-1.5,0 -2.7,-0.8 -3.4,-1.9l-3.8,2.3l0,9.3l14.5,0l0,-9.3l-3.9,-2.4c-0.7,1.2 -1.9,2 -3.4,2z",
    fill: "none",
    id: "svg_18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m18.9,17.5l0,-10l-4.9,-3c0,-0.1 0,-0.3 0,-0.5c0,-2.2 -1.8,-4 -4,-4s-4,1.8 -4,4c0,0.2 0,0.4 0.1,0.6l-4.8,2.9l0,10l-1,0l0,2l19.4,0l0,-2l-0.8,0zm-11.1,-13.9l0,-0.3l0.5,0l1,0l0,-0.7l0,-0.8l1.5,0l0,0.9l0,0.6l1,0l0.5,0l0,0.3l0,1.2l-0.9,0l-0.6,0l0,1.5l-1.6,0l0,-1.5l-0.5,0l-0.9,0l0,-1.2zm-5,4.8l3.8,-2.3c0.7,1.1 1.9,1.9 3.4,1.9c1.5,0 2.7,-0.8 3.4,-2l3.9,2.4l0,9.1l-1.3,0l0,-3.5l-12,0l0,3.5l-1.2,0l0,-9.1zm11.2,9.1l-2.4,0l0,-2.5l2.4,0l0,2.5zm-3.2,0l-1.5,0l0,-2.5l1.5,0l0,2.5zm-2.3,0l-2.5,0l0,-2.5l2.5,0l0,2.5z",
    fill: "#F0396D",
    id: "svg_19"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClinic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clinic.62d35057.svg";
export { ForwardRef as ReactComponent };